import * as React from 'react'
import styled from 'styled-components'

import { t } from '@owl-nest/localize'
import * as plume from '@ulule/owl-kit-components/next'

import { DashedLine, DashedLineXS, Pop } from './Vectors'

export function Mission(): React.ReactElement {
  return (
    <MissionWrapper>
      <TextWrapper>
        <plume.styles.heading.XXS asDesktop="S">
          {t('What do all these services have in common?')}
          <Pop />
        </plume.styles.heading.XXS>
        <plume.styles.heading.S asDesktop="L">
          {t('They give wings to those who are committed to building a more creative and sustainable world.')}
        </plume.styles.heading.S>
      </TextWrapper>
      <DashedLine />
      <DashedLineXS />
    </MissionWrapper>
  )
}

const MissionWrapper = styled.div`
  position: relative;
  margin: 80px 0;
  display: flex;
  justify-content: center;
  text-align: center;

  ${plume.styles.heading.L}, ${plume.styles.heading.S} {
    position: relative;
    font-style: italic;

    &::after {
      content: '';
      position: absolute;
      top: -12px;
      left: 50%;
      transform: translateX(-50%);
      width: 60px;
      height: 4px;
      background-color: ${plume.COLORS.PRIMARY_BLUE};
    }
  }

  ${DashedLine} {
    display: none;
  }

  ${DashedLineXS} {
    position: absolute;
    left: 0;
    top: -5%;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    ${DashedLineXS} {
      left: 1%;
      top: 5%;
      transform: rotateZ(-10deg) scale(1.5);
    }

    ${plume.styles.heading.S} {
      margin-bottom: 40px;
    }
  }

  @media screen and (min-width: 1258px) {
    ${DashedLine} {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
    }

    ${DashedLineXS} {
      display: none;
    }

    ${plume.styles.heading.S} {
      margin-bottom: 0px;
    }
  }
`

const DesktopView = styled.div`
  display: none;
`

const TextWrapper = styled.div`
  position: relative;
  display: block;
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  ${plume.styles.heading.XXS} {
    max-width: 300px;
  }

  ${plume.styles.heading.S} {
    max-width: 335px;
  }

  ${Pop} {
    position: absolute;
    right: 0;
    top: 0;
    transform: rotateY(180deg) scale(0.7);
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    height: 180px;

    ${plume.styles.heading.XXS} {
      max-width: revert;
    }

    ${plume.styles.heading.S} {
      max-width: 800px;
    }

    ${Pop} {
      right: 18%;
      transform: rotateY(180deg) scale(1);
    }
  }
`
